"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var JStorage = __importStar(require("../../Actions/JStorage"));
var antd_1 = require("antd");
var moment_1 = __importDefault(require("moment"));
var RichTextEditor_1 = __importDefault(require("../../Components/RichTextEditor"));
var ArticleEditorUtil_1 = require("../../Components/ArticleEditor/ArticleEditorUtil");
var RevArticleWidget = function RevArticleWidget(props) {
  var value = props.value,
    onChange = props.onChange;
  var _a = react_1.useState(false),
    visible = _a[0],
    setVisible = _a[1];
  var _b = react_1.useState(null),
    article = _b[0],
    setArticle = _b[1];
  var _c = react_1.useState(),
    content = _c[0],
    setContent = _c[1];
  var _d = react_1.useState({
      title: ''
    }),
    values = _d[0],
    setValues = _d[1];
  var _fetchArticle = react_1.useCallback(function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var _article, id, created, updated, content, html, rest;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, JStorage.fetchOneDocument('Article_Default', {
              id: value
            }, null)];
          case 1:
            _article = _a.sent();
            setArticle(_article);
            setContent(_article.content);
            id = _article.id, created = _article.created, updated = _article.updated, content = _article.content, html = _article.html, rest = __rest(_article, ["id", "created", "updated", "content", "html"]);
            setValues(rest);
            return [2 /*return*/];
        }
      });
    });
  }, [value]);
  react_1.useEffect(function () {
    if (value) {
      _fetchArticle();
    }
  }, [_fetchArticle, value]);
  var submit = function submit() {
    return __awaiter(void 0, void 0, void 0, function () {
      var record, _a;
      var _b;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            _a = [__assign(__assign({}, article), values)];
            _b = {
              content: content
            };
            return [4 /*yield*/, ArticleEditorUtil_1.generateHtml(content)];
          case 1:
            record = __assign.apply(void 0, _a.concat([(_b.html = _c.sent(), _b)]));
            return [4 /*yield*/, ArticleEditorUtil_1.upsertArticle(record, article, {
              onUpdate: function onUpdate(_doc) {
                onChange(_doc === null || _doc === void 0 ? void 0 : _doc.id);
                setArticle(_doc);
              },
              onClose: function onClose() {
                return setVisible(false);
              }
            })];
          case 2:
            _c.sent();
            return [2 /*return*/];
        }
      });
    });
  };

  return react_1.default.createElement(react_1.Fragment, null, !value ? react_1.default.createElement(antd_1.Button, {
    style: {
      margin: '10px 0'
    },
    onClick: function onClick() {
      setVisible(true);
    }
  }, "\u5275\u5EFA\u6587\u7AE0") : react_1.default.createElement("div", null, react_1.default.createElement(antd_1.Button, {
    style: {
      margin: '10px 0'
    },
    onClick: function onClick() {
      setVisible(true);
    }
  }, "\u7DE8\u8F2F\u6587\u7AE0"), article && react_1.default.createElement(antd_1.Card, {
    style: {
      width: 300
    }
  }, react_1.default.createElement(antd_1.Card.Meta, {
    title: article.title,
    description: "\u66F4\u65B0\u65BC " + moment_1.default(article.updated).format('YYYY-MM-DD hh:mm')
  }))), react_1.default.createElement(antd_1.Modal, {
    footer: null,
    width: "70%",
    onCancel: function onCancel() {
      setVisible(false);
    },
    visible: visible
  }, react_1.default.createElement("div", {
    style: {
      paddingTop: 40
    }
  }, react_1.default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: 10
    }
  }, react_1.default.createElement("label", {
    style: {
      flexShrink: 0,
      marginRight: 5
    }
  }, "\u6A19\u984C"), react_1.default.createElement(antd_1.Input, {
    value: values.title,
    onChange: function onChange(e) {
      return setValues(function (prev) {
        return __assign(__assign({}, prev), {
          title: e.target.value
        });
      });
    }
  })), react_1.default.createElement(RichTextEditor_1.default, {
    options: {},
    token: "",
    onChange: function onChange(value) {
      return setContent(value);
    },
    content: content
  }), react_1.default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  }, react_1.default.createElement(antd_1.Button, {
    onClick: submit
  }, article ? '編輯' : '建立')))));
};
exports.default = RevArticleWidget;